import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HippaCompliance } from '../Models/hippacompliance.model';

@Injectable({
  providedIn: 'root'
})
export class HippaComplianceService {


  url = environment.Url+'HippaCompliances';

  header = new HttpHeaders({

    'Authorization': 'token' + localStorage.getItem('token')

  })

  constructor(private http: HttpClient) { }




  registerHippaCompliance(body){
    return this.http.post<HippaCompliance>(this.url,body).pipe(
     catchError(this.handleError)
   );
     }

   getHippaCompliances(){
    return this.http.get<HippaCompliance[]>(this.url).pipe(catchError(this.handleError)
    
    );
   }
   getHippaComplianceById(id){
    return this.http.get<HippaCompliance>(this.url+'/'+id)
  }

  updateHippaCompliance(id,body){
   return this.http.put<HippaCompliance>(this.url+'/'+id,body).pipe(catchError(this.handleError));
  }

  deleteHippaCompliance(id){
return this.http.delete<HippaCompliance>(this.url+'/'+id).pipe(catchError(this.handleError));
  }



  
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error)
        return throwError(
          error.error
        )


      }
     else if(error.status ==401){
       return throwError('invalid username or password')

     }
      else if (error.status == 0) {
        return throwError(
          'network failure please try again later '
        )
      }
      return throwError(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


}



